<template>
  <div class="wrp">
    <div class="invoice-update-wrp">
      <div class="margin-btm">
        <van-cell-group :border="false" class="border-btm">
          <van-field
            label="发票标签"
            @click="tagVisible = true"
          >
            <input slot="input" class="input" type="text" v-model="editData.tag" placeholder="请选择标签" readonly>
          </van-field>
        </van-cell-group>
        <van-cell-group :border="false">
          <van-field
            label="备注"
          >
            <input slot="input" class="input" type="text" v-model="editData.customRemark" placeholder="请输入">
          </van-field>
        </van-cell-group>
      </div>
      <p class="tips">
        请确认发票信息是否与票面相符
      </p>
      <div>
        <van-cell-group :border="false">
          <van-field
            label="票据类型"
          >
            <input slot="input" :class="['input', 'disabled-input'].join(' ')" type="text" v-model="editData.invoiceTypeName" placeholder="请选择发票类型" readonly>
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.ocrSellerName" :border="false" class="border-btm">
          <van-field
            label="销方名称"
            placeholder="请选择标签"
            readonly
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.ocrSellerName">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.ocrDrewDate" :border="false" class="border-btm">
          <van-field
            label="开票日期"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.ocrDrewDate">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.drewDate && !invoiceInfo.ocrDrewDate" :border="false" class="border-btm">
          <van-field
            label="开票日期"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.drewDate">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.invoiceCode" :border="false" class="border-btm">
          <van-field
            label="发票代码"
          >
            <input v-show="invoiceInfo.ocrInvoiceCode" slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.ocrInvoiceCode">
            <input v-show="!invoiceInfo.ocrInvoiceCode" slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.invoiceCode">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.invoiceNo || invoiceInfo.ocrInvoiceNo" :border="false" class="border-btm">
          <van-field
            label="发票号码"
          >
            <input slot="input" :readonly="!canEditAll" v-show="invoiceInfo.invoiceNo" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.ocrInvoiceNo">
            <input slot="input" :readonly="!canEditAll" v-show="!invoiceInfo.ocrInvoiceNo" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.invoiceNo">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.ocrAmount && invoiceInfo.invoiceType === '01'" :border="false" class="border-btm">
          <van-field
            label="不含税金额"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.ocrAmount">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.passengerName" :border="false" class="border-btm">
          <van-field
            label="姓名"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.passengerName">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.mileage" :border="false" class="border-btm">
          <van-field
            label="里程"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.mileage">
          </van-field>
        </van-cell-group>
        <van-cell-group v-if="invoiceInfo.detailList && invoiceInfo.detailList.length" :border="false" class="border-btm">
          <van-field
            label="起始地"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.detailList[0].flyFrom">
          </van-field>
        </van-cell-group>
        <van-cell-group v-if="invoiceInfo.detailList && invoiceInfo.detailList.length" :border="false" class="border-btm">
          <van-field
            label="客票号码"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.detailList[0].ticketId">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.checkCode" :border="false" class="border-btm">
          <van-field
            :label="invoiceInfo.invoiceType === '202' ? '验证码' : '校验码'"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.checkCode">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.ountWithTax && invoiceInfo.invoiceType === '202'" :border="false" class="border-btm">
          <van-field
            label="金额（含税）"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.ountWithTax">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.fare && invoiceInfo.invoiceType === '202'" :border="false" class="border-btm">
          <van-field
            label="票价"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.fare">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.caacDevelopmentFund" :border="false" class="border-btm">
          <van-field
            label="民航发展基金"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.caacDevelopmentFund">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.caacDevelopmentFund" :border="false" class="border-btm">
          <van-field
            label="燃油附加费"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.fuelSurcharge">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.getOnDate" :border="false" class="border-btm">
          <van-field
            label="乘车日期"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.getOnDate">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.timeGetOn" :border="false" class="border-btm">
          <van-field
            label="上车时间"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.timeGetOn">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.timeGetOff" :border="false" class="border-btm">
          <van-field
            label="下车时间"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.timeGetOff">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.trainNumber" :border="false" class="border-btm">
          <van-field
            label="车次"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.trainNumber">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.seat" :border="false" class="border-btm">
          <van-field
            label="座位类型"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.seat">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.stationGetOn" :border="false" class="border-btm">
          <van-field
            label="上车车站"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.stationGetOn">
          </van-field>
        </van-cell-group>
        <van-cell-group v-show="invoiceInfo.stationGetOff" :border="false" class="border-btm">
          <van-field
            label="下车车站"
          >
            <input slot="input" :readonly="!canEditAll" :class="['input', canEditAll ? '' : 'disabled-input'].join(' ')" type="text" v-model="editData.stationGetOff">
          </van-field>
        </van-cell-group>
      </div>
      <div>
      </div>
    </div>
    <MyActionSheet
      :columns="invoiceList"
      :visible="invoiceVisible"
      @cancel="invoiceVisible = false"
      @confirm="onInvoiceTypeConfirm"
      type="invoiceType"
    />
    <MyActionSheet
      :columns="tagList"
      :visible="tagVisible"
      @cancel="tagVisible = false"
      @confirm="onTagConfirm"
      type="tag"
    />
    <div class="btn-wrp">
      <van-button
        class="btn"
        round
        @click="back"
      >
        取消
      </van-button>
      <van-button
        class="btn"
        round
        @click="updateInvoice"
      >
        保存
      </van-button>
    </div>
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Popup,
  Field,
  Button,
  picker,
  DatetimePicker,
  Toast,
  Notify,
  Divider,
  Dialog,
  Icon
} from 'vant'
import { getQuery, ConvertNumber, deepCopy } from '@utils/basicUtil'
import moment from 'moment'
import { officialAccountRequest } from '@services'
import MyActionSheet from '@components/OfficialAccount/ActionSheet'
export default {
  data () {
    return {
      type: 0,
      id: '',
      invoiceInfo: {},
      editData: {},
      canEditAll: false,
      tagList: [
        { name: '餐费' },
        { name: '招待费' },
        { name: '差旅费' },
        { name: '通讯费' },
        { name: '交通费' }
      ],
      invoiceList: [
        {
          name: '增值税专用发票',
          id: '01'
        },
        {
          name: '增值税普通发票',
          id: '04'
        },
        {
          name: '增值税电子发票',
          id: '10'
        },
        {
          name: '增值税卷式发票',
          id: '11'
        },
        {
          name: '航空客票行程单',
          id: '202'
        },
        {
          name: '定额发票',
          id: '200'
        },
        {
          name: '火车票',
          id: '201'
        },
        {
          name: '出租车发票',
          id: '207'
        }
      ],
      invoiceVisible: false,
      tagVisible: false
    }
  },
  computed: {
  },
  mounted () {
    this.getQuery()
    this.getInvoiceDetail()
  },
  methods: {
    getQuery () {
      this.id = getQuery().id
      this.type = Number(getQuery().type)
    },
    moment (data) {
      return moment(Number(data)).format('YYYY-MM-DD')
    },
    back () {
      this.$router.go(-1)
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    getInvoiceDetail () {
      if (this.type === 0) {
        this.getNonVat()
      } else {
        this.getVat()
      }
    },
    async getNonVat () {
      const data = await officialAccountRequest.weChat.getNonVat({}, { id: this.id })
      if (data.success) {
        this.invoiceInfo = data.result
        this.editData = deepCopy(data.result)
        this.editData.invoiceTypeName = this.invoiceTypeName(data.result.invoiceType)
        this.canEditAll = true
      } else {
        Notify({ type: 'danger', message: data.message })
        this.back()
      }
    },
    async getVat () {
      const data = await officialAccountRequest.weChat.getVat({}, { id: this.id })
      if (data.success) {
        this.invoiceInfo = data.result.weChatVatInvoice
        this.editData = deepCopy(data.result.weChatVatInvoice)
        this.editData.invoiceTypeName = this.invoiceTypeName(data.result.weChatVatInvoice.invoiceType)
        if (data.result.weChatVatInvoice.checkFlag !== 1) {
          this.canEditAll = true
        }
      } else {
        Notify({ type: 'danger', message: data.message })
        this.back()
      }
    },
    invoiceTypeName (invoiceType) {
      switch (invoiceType) {
        case '01':
          return '增值税专用发票'
        case '04':
          return '增值税普通发票'
        case '10':
          return '增值税电子发票'
        case '11':
          return '增值税卷式发票'
        case '202':
          return '航空客票行程单'
        case '200':
          return '定额发票'
        case '201':
          return '火车票'
        case '207':
          return '出租车发票'
        default:
          break
      }
    },
    updateInvoice () {
      Dialog.confirm({
        title: '提示',
        message: '确认修改该发票数据'
      }).then(() => {
        switch (this.invoiceInfo.invoiceType) {
          case '01':
          case '04':
          case '10':
          case '11':
            this.vatUpdate()
            break
          case '202':
          case '200':
          case '201':
          case '207':
            this.nonVatUpdate()
            break
          default:
            break
        }
      })
    },
    async nonVatUpdate () {
      const data = await officialAccountRequest.weChat.nonVatUpdate({ ...this.editData })

      if (data.success) {
        Notify({ type: 'success', message: '修改成功' })
        this.back()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async vatUpdate () {
      let newData = {}
      if (this.editData.invoiceType === '11' || this.editData.invoiceType === '04' || this.editData.invoiceType === '10') {
        newData.ocrCheckCode = this.editData.checkCode
      }
      const {
        customRemark,
        id,
        ocrAmount,
        ocrAmountWithTax,
        ocrCheckCode,
        ocrDrewDate,
        ocrInvoiceCode,
        ocrInvoiceNo,
        ocrInvoiceType,
        ocrPurchaserName,
        ocrPurchaserTaxNo,
        ocrSellerName,
        ocrSellerTaxNo,
        ocrTaxAmount,
        tag
      } = { ...this.editData, ...newData }

      const data = await officialAccountRequest.weChat.vatUpdateAndCommit({ ticketInfo:
        {
          customRemark,
          id,
          ocrAmount,
          ocrAmountWithTax,
          ocrCheckCode,
          ocrDrewDate,
          ocrInvoiceCode,
          ocrInvoiceNo,
          ocrInvoiceType,
          ocrPurchaserName,
          ocrPurchaserTaxNo,
          ocrSellerName,
          ocrSellerTaxNo,
          ocrTaxAmount,
          tag
        }
      })
      if (data.success) {
        Notify({ type: 'success', message: '修改成功' })
        this.back()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    onTagConfirm (data) {
      this.tagVisible = false
      this.editData.tag = data.value.name
    },
    onInvoiceTypeConfirm (data) {
      this.invoiceVisible = false
      this.editData.invoiceType = data.value.id
      this.editData.invoiceTypeName = data.value.name
    }
  },
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [picker.name]: picker,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast,
    [Notify.name]: Notify,
    [Divider.name]: Divider,
    [Icon.name]: Icon,
    MyActionSheet
  }
}
</script>
<style lang="less" scoped src="./style.less" />
